export default "__VITE_ASSET__B$wk60OD__"